module.exports = __webpack_public_path__ + "assets/img/003.21c6b581.png";